var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3,3.5h1.4v1.4h-1.4v-1.4ZM6.3,6.3h1.4v4.2h-1.4v-4.2ZM7,0C3.14,0,0,3.14,0,7s3.14,7,7,7,7-3.14,7-7S10.86,0,7,0ZM7,12.6c-3.09,0-5.6-2.51-5.6-5.6S3.91,1.4,7,1.4s5.6,2.51,5.6,5.6-2.51,5.6-5.6,5.6Z",
    fill: "currentColor"
  })));
};
export default SvgInfo;